var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSlackinline = function SvgSlackinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#3B2642"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    fillRule: "evenodd",
    d: "M26.665 12.002A3.998 3.998 0 1 0 26.666 20h4v-3.997a4.003 4.003 0 0 0-4.001-4.001c.001 0 .001 0 0 0m0 10.666H16a4 4 0 0 0-.001 8h10.666a4 4 0 1 0 0-8",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    fillRule: "evenodd",
    d: "M52.001 26.665a4 4 0 0 0-4-4 4 4 0 0 0-4 4v4h4a4 4 0 0 0 4-4m-10.666 0V15.999a4 4 0 0 0-8 0v10.666a4 4 0 1 0 8 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    fillRule: "evenodd",
    d: "M37.327 51.994a4 4 0 1 0 0-7.998h-4v4a4.002 4.002 0 0 0 4 3.998m0-10.667h10.666a4 4 0 0 0 .001-8H37.328a4 4 0 0 0-.002 8",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    fillRule: "evenodd",
    d: "M12 37.333a4 4 0 0 0 8 0v-3.999h-4a4 4 0 0 0-4 3.999m10.666 0v10.666a4 4 0 0 0 8 .001V37.336a4 4 0 0 0-8-.003s0 .002 0 0",
    clipRule: "evenodd"
  })));
};
export default SvgSlackinline;